"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var ErrorDisplay = function (_a) {
    var id = _a.id, errorMessage = _a.errorMessage, role = _a.role, ariaLive = _a["aria-live"];
    if (errorMessage) {
        return ((0, jsx_runtime_1.jsx)(FormHelperText_1.default, { id: id, error: true, role: role, "aria-live": ariaLive, children: errorMessage }));
    }
    return null;
};
exports.default = ErrorDisplay;
//# sourceMappingURL=ErrorDisplay.js.map